/**
 * Vue directive for tracking clicks with Google Analytics
 * 
 * Usage:
 *   <button v-ga-event="'save-button'">Save</button>
 *   <button v-ga-event.button="'save'">Save</button>
 *   <div v-ga-event.tab="'dashboard'">Dashboard</div>
 *   <button v-ga-event="{ name: 'save', label: 'Save Site', category: 'button' }">Save</button>
 */
export default {
  bind(el, binding) {
    const handleClick = () => {
      if (typeof window === 'undefined' || !window.gtag) return;

      let eventName;
      let eventCategory = 'engagement';
      let eventLabel = null;
      let customParams = {};

      // Parse binding value
      if (typeof binding.value === 'string') {
        eventName = binding.value;
        eventLabel = el.getAttribute('aria-label') || el.textContent?.trim() || null;
      } else if (typeof binding.value === 'object' && binding.value !== null) {
        eventName = binding.value.name || binding.value.event_name || 'click';
        eventCategory = binding.value.category || binding.value.event_category || 'engagement';
        eventLabel = binding.value.label || binding.value.event_label || el.getAttribute('aria-label') || el.textContent?.trim() || null;
        customParams = binding.value.params || {};
      } else {
        eventName = 'click';
        eventLabel = el.getAttribute('aria-label') || el.textContent?.trim() || null;
      }

      // Determine category from modifier
      if (binding.modifiers.button) {
        eventCategory = 'button';
        eventName = eventName || 'button_click';
      }
      if (binding.modifiers.tab) {
        eventCategory = 'tab';
        eventName = eventName || 'tab_click';
      }
      if (binding.modifiers.action) {
        eventCategory = 'action';
        eventName = eventName || 'custom_action';
      }

      // Send event to Google Analytics
      window.gtag('event', eventName, {
        event_category: eventCategory,
        event_label: eventLabel,
        ...customParams,
      });
    };

    el._gaEventHandler = handleClick;
    el.addEventListener('click', handleClick);
  },
  unbind(el) {
    if (el._gaEventHandler) {
      el.removeEventListener('click', el._gaEventHandler);
      delete el._gaEventHandler;
    }
  },
};
